const pojemnoscSkokowa = { t: 'Pojemność', type: 'range', name: 'pojemnosc', unit: 'cm³', hint: { url: '/displacement_capacity' }}
export default pojemnoscSkokowa